<template>
    <el-dialog title="临时修改" :visible.sync="dialogVisible" width="50%" :append-to-body="true" :center="true" :wrapperClosable="false">
        <el-form label-width="120px" :model="ruleForm">
            <el-form-item label="请选择供应商">
                <el-select v-model="ruleForm.supplier_id" filterable clearable @change="getProducts(ruleForm.supplier_id)">
                    <el-option
                        v-for="(item, index) in suppliers"
                        placeholder="请选择供应商"
                        :key="index"
                        :label="item.title"
                        :value="item.id + ''"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="请选择产品">
                <el-select v-model="ruleForm.product_id" filterable clearable @change="change">
                    <el-option
                        v-for="(item, index) in product"
                        placeholder="请选择产品"
                        :key="index"
                        :label="item.title"
                        :value="item.id + ''"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否作废" v-if="type != 'fourEdit'">
                <el-select v-model="ruleForm.invalid_id" clearable :filterable="true" placeholder="请选择是否作废">
                    <el-option key="event_date" label="是" value="0"></el-option>
                    <el-option key="sign_date" label="否" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="其他费用" v-if="type == 'fourEdit'">
                <el-input v-model="ruleForm.other_fee" type="number" placeholder="请输入价格"></el-input>
            </el-form-item>
            <el-form-item label="自定义价格" v-else>
                <el-input v-model="ruleForm.price" type="number" placeholder="请输入价格"></el-input>
            </el-form-item>
            <el-form-item label="数量" v-if="type != 'fourEdit'">
                <el-input v-model="ruleForm.count" type="number" placeholder="请输入价格"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="ruleForm.remark" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item v-if="type == 'fourEdit'">
                <el-button type="primary" @click="submitFour">四大确认</el-button>
                <el-button @click="closeDrawer">取消</el-button>
            </el-form-item>
            <el-form-item v-else>
                <el-button type="primary" @click="submit">确认</el-button>
                <el-button @click="closeDrawer">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
const ruleForm = {
    supplier_id: '',
    product_id: '',
    remark: '',
    count: '',
    price: '',
    invalid_id: '',
    other_fee: ''
};
export default {
    props: {
        parent: {}
    },
    data() {
        return {
            supplier_id: '',
            dialogVisible: false,
            ruleForm: Object.assign({}, ruleForm),
            suppliers: [],
            forms: [],
            cid: 0,
            applyItem: {},
            product: [],
            parentId: '',
            type: '',
            foruId: '',
            orderId: '',
            row: ''
        };
    },
    created() {},
    methods: {
        //四大金刚
        showFour(row, categoryId, type) {
            let _this = this;
            _this.dialogVisible = true;
            _this.type = type;
            _this.row = row;
            _this.ruleForm.other_fee = row.other_fee;
            _this.ruleForm.remark = row.remark;
            if (type == 'fourEdit') {
                _this.foruId = row.id;
                _this.orderId = row.order_id;
            }
            if (row.supplier_id) {
                _this.ruleForm.supplier_id = row.supplier_id + '';
                _this.getProducts(row.supplier_id + '');
                _this.ruleForm.product_id = row.product_id + '';
            }
            // 获取分类列表
            // 获取分类列表
            let url = '/api/supplier.company/index';
            _this
                .$post(url, {
                    category_parent_id: categoryId
                })
                .then((res) => {
                    let resData = res.data;
                    _this.suppliers = resData.list;
                });
        },
        //总控需求单
        showDialog(row, suppliers, parentId) {
            let _this = this;
            _this.ruleForm = Object.assign({}, ruleForm);
            _this.applyItem = row;
            _this.parentId = parentId;
            this.suppliers = suppliers;
            if (row.supplier || row.product) {
                _this.ruleForm = Object.assign({}, row);
                _this.getProducts(row.supplier.id + '');
                _this.ruleForm.supplier_id = row.supplier.id + '';
                if (row.product) {
                    _this.ruleForm.product_id = row.product.id + '';
                }
            } else {
                _this.ruleForm.remark = row.remark;
                _this.ruleForm.price = row.price;
                _this.ruleForm.invalid_id = row.invalid_id;
                _this.ruleForm.count = row.count;
            }
            _this.applyItem = row;
            _this.dialogVisible = true;
        },
        //总控项目管理
        showProject(row) {
            let _this = this;
            _this.ruleForm = Object.assign({}, ruleForm);
            _this.applyItem = row;
            _this.getSuppliersProject();
            if (row.supplier || row.product) {
                _this.ruleForm = Object.assign({}, row);
                _this.getProducts(row.supplier_id);
                _this.ruleForm.supplier_id = row.supplier_id + '';
                if (row.product) {
                    _this.ruleForm.product_id = row.product_id + '';
                }
            }
            _this.applyItem = row;
            _this.dialogVisible = true;
        },
        getSuppliers() {
            let _this = this;
            let url = '/api/supplier.company/index';
            let params = {
                category_parent_id: _this.parentId
            };
            _this.$post(url, params).then((res) => {
                if (res.code == '200') {
                    _this.suppliers = res.data.list;
                }
            });
        },
        getSuppliersProject() {
            let _this = this;
            let url = '/api/supplier.company/index';
            let params = {
                category_parent_id: 2
            };
            _this.$post(url, params).then((res) => {
                if (res.code == '200') {
                    _this.suppliers = res.data.list;
                }
            });
        },
        getProducts(value) {
            let _this = this;
            _this.ruleForm.product_id = '';
            let url = '/api/supplier.product/group';
            _this
                .$post(url, {
                    supplier_id: value,
                    category_id: _this.parentId
                })
                .then((res) => {
                    _this.product = res.data.list;
                });
        },
        change() {
            this.$forceUpdate();
        },

        // 先保留吧,使用的地方太多了
        closeDrawer() {
            this.dialogVisible = false;
        },
        //四大金刚提交
        submitFour() {
            let _this = this;
            if (this.ruleForm.supplier_id == '') {
                _this.$message.error('请填写供应商');
                return false;
            }
            if (this.ruleForm.product_id == '') {
                _this.$message.error('请填写产品');
                return false;
            }

            this.ruleForm = Object.assign({}, this.ruleForm);
            _this.$set(this.applyItem, 'price', this.ruleForm.price);
            _this.$set(this.applyItem, 'count', this.ruleForm.count);
            _this.$set(this.applyItem, 'remark', this.ruleForm.remark);
            _this.$set(this.applyItem, 'invalid_id', this.ruleForm.invalid_id);
            this.dialogVisible = false;
            let url = '/api/wedding.four/update';
            let params = {
                ..._this.ruleForm,
                id: _this.foruId,
                order_id: _this.orderId
            };
            _this.$post(url, params).then((res) => {
                if (res.code == 200) {
                    _this.$message.success(res.msg);
                    _this.$parent.$parent.getDate(_this.row);
                    _this.$parent.$parent.$parent.getTableData();
                }
            });
        },
        submit() {
            let _this = this;
            if (this.ruleForm.supplier_id == '') {
                _this.$message.error('请填写供应商');
                return false;
            }
            if (this.ruleForm.product_id == '') {
                _this.$message.error('请填写产品');
                return false;
            }
            let target = this.suppliers.find((ele) => ele.id == this.ruleForm.supplier_id);
            let targetPro = this.product.find((ele) => ele.id == this.ruleForm.product_id);

            this.ruleForm = Object.assign({}, this.ruleForm);
            _this.$set(this.applyItem, 'price', this.ruleForm.price);
            _this.$set(this.applyItem, 'count', this.ruleForm.count);
            _this.$set(this.applyItem, 'remark', this.ruleForm.remark);
            _this.$set(this.applyItem, 'invalid_id', this.ruleForm.invalid_id);
            this.applyItem.supplier = target;
            this.applyItem.product = targetPro;
            this.$parent.$forceUpdate();
            this.dialogVisible = false;
        }
    }
};
</script>
